/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.14.1
 */

export enum EWizardBillsDocWithDetailStatus {
    disable = 'disable',
    enable = 'enable',
    partially = 'partially',
}

export interface IWizardBillsDocOrderResult {
    orderId: string;
    actErrorAccount?: string;
    actsCount: number;
    actsErrorCount: number;
    billErrorAccount?: string;
    billsCount: number;
    billsErrorCount: number;
    fuctErrorAccount?: string;
    fuctsCount: number;
    fuctsErrorCount: number;
    invoicesCount: number;
    invoicesErrorAccount?: string;
    invoicesErrorCount: number;
}
